import LayautContext from 'Context/ContextLayaut';
import { useContext } from 'react';

const ServiciosVentas = () => {
    const context = useContext(LayautContext);
    return {
        getPermisosPaginaByRol: context.llamarServidor('Catalogo/getPermisosPaginaByRol'),
        getInfoCurso: context.llamarServidorRespuesta('Dashboard/getInfoCurso'),
        Allcursos: context.llamarServidor('HomeVentas/Allcursos'),
        buscaCursosColab: context.llamarServidor('HomeVentas/buscaCursosColab'),
        getInfoCursoSesiones: context.llamarServidor('Dashboard/getsesionCurso'),
        getInfoTemario: context.llamarServidor('Dashboard/getTemarioSesion'),
        getActividadTema: context.llamarServidor('Dashboard/getActividadTema'),
        getInfoActividad: context.llamarServidor('HomeVentas/getInfoActividad'),
        sendRespuestas: context.llamarServidorRespuesta('HomeVentas/sendRespuestas'),
        // colaboradoresMiSede: context.llamarServidor('HomeVentas/colaboradoresMiSede/'),
        getBannersAndVideos: context.llamarServidor('HomeVentas/getBannersAndVideos/'),
        getMisCalificacionesEvidencia: context.llamarServidor('HomeVentas/getMisCalificacionesEvidencia'),

        reiniciarExamen: context.llamarServidorRespuesta('HomeVentas/reiniciarExamenV2/'),
        buscaDatosCursoActual: context.llamarServidor('HomeVentas/buscaDatosCursoActual/'),
        enviaCalificacionDetalle: context.llamarServidorRespuesta('HomeVentas/enviaCalificacionDetalle'),
        marcarVideoDepartamentoVisto: context.llamarServidor('HomeVentas/marcarVideoDepartamentoVisto'),
        getVideoDepartamento: context.llamarServidor('HomeVentas/getVideoDepartamento'),
        marcarVideoDepartamentoVerNuevamente: context.llamarServidor('HomeVentas/marcarVideoDepartamentoVerNuevamente'),
        marcarVideoBienvenidaVisto: context.llamarServidor('HomeVentas/marcarVideoBienvenidaVisto'),
        marcarVideoBienvenidaVerNuevamente: context.llamarServidor('HomeVentas/marcarVideoBienvenidaVerNuevamente'),
        getMaterialesPendientesPeriodo: context.llamarServidor('HomeVentas/getMaterialesPendientesPeriodo')
    };
};

export default ServiciosVentas;
